module.exports = __webpack_public_path__ + "img/chris3.c60aae00.jpg";